import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { InfinitySpin } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { getData, postData } from "../../FetchNodeServices";
import AlertMessages from "../Mains/Alerts";
import { useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";

const AddUser = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullWidthWrapper, setFullWidthWrapper] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fullName, setFullName] = useState("");
  const [emailId, setEmailId] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [teamOptions, setTeamOptions] = useState([]);
  const [team, setTeam] = useState(null);
  const [userType, setUserType] = useState("U");
  const [userStatus, setUserStatus] = useState(1);
  const [alerts, setAlerts] = useState([]);
  const customer = useSelector((state) => state.user.users[0]);
  const user = customer.userId;
  let navigate = useNavigate();

  // Fetch teams from backend on component mount
  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await getData(`users/teams`);

        const options = response.map((team) => ({ value: team, label: team }));
        setTeamOptions(options);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };

    fetchTeams();
  }, []);

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullWidthWrapper(isActivated ? "fullwrapper" : "");
  };

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    
    // General email validation pattern for local part and domain
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    
    // Split the email into parts for more custom validation
    const [localPart, domainPart] = emailValue.split("@");
  
    // General email pattern validation
    if (!emailRegex.test(emailValue)) {
      setEmailError("Invalid email address format");
    } else if (domainPart && domainPart.split(".").length !== 2) {
      // Ensure there's exactly one dot in the domain part (no subdomains)
      setEmailError("Domain should contain only one dot after '@'");
    } else if (domainPart && domainPart.split(".")[1].length < 2 || domainPart.split(".")[1].length > 4) {
      // Ensure the TLD (suffix) is between 2 to 4 characters long
      setEmailError("Domain suffix should be 2 to 4 characters long");
    } else {
      // Clear any previous errors
      setEmailError(null);
    }
    
    setEmailId(emailValue);
  };

  const handleSubmit = async () => {
    if (!fullName || !emailId || !team || !userType || !userStatus || emailError) {
      setAlerts([
        {
          variant: "danger",
          heading: "Please fill all the required fields correctly!",
        },
      ]);
      return;
    }

    var formData = {
      fullName: fullName,
      email: emailId,
      team: team.value,
      userRole: userType,
      status: userStatus,
    };

    setIsLoading(true);
    var result = await postData(`users/add-user?userId=${user}`, formData);

    if (result) {
      let mail = await postData(`users/account-creation-mail/${result.userId}`);
      setAlerts([{ variant: "success", heading: "User Added Successfully!" }]);

      if (mail) {
        setAlerts([{ variant: "success", heading: "Password Mail sent Successfully!" }]);
        setTimeout(() => navigate("/user-management"), 3000);
      }

      setIsLoading(false);
    } else {
      setAlerts([
        {
          variant: "danger",
          heading: "Error in Adding User! Try Again Later.",
        },
      ]);
    }
  };

  const handleClear = () => {
    setFullName("");
    setEmailId("");
    setTeam(null);
    setUserType("U");
    setUserStatus(1);
  };

  const customComponents = {
    DropdownIndicator: null,
    IndicatorSeparator: null,
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px",
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#80bdff",
      },
      boxShadow: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 6px",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
  };

  // Function to handle new team creation or selection
  const handleTeamChange = (newValue, actionMeta) => {
    if (actionMeta.action === "create-option") {
      const newTeam = { value: newValue.value, label: newValue.value };
      setTeam(newTeam);
      setTeamOptions([...teamOptions, newTeam]);
    } else if (actionMeta.action === "select-option") {
      setTeam(newValue);
    }
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullWidthWrapper}>
        <Header onclick={handleToggle} />
        {isLoading && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1050 }}>
            <div className="p-5 rounded">
              <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
            </div>
          </div>
        )}
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> User Management
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-app-indicator mx-2"></i> User Details
              </li>
            </ul>
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="common_form p-3">
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="fullName">Full Name</label>
                    <input
                      type="text"
                      value={fullName}
                      className="form-control"
                      placeholder="Enter Full Name"
                      onChange={(event) => setFullName(event.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="team">Team</label>
                    <CreatableSelect
                      isClearable
                      value={team}
                      options={teamOptions}
                      onChange={handleTeamChange}
                      placeholder="Select or type team"
                      components={customComponents}
                      styles={customStyles}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      value={emailId}
                      className="form-control"
                      placeholder="Enter email id"
                      onChange={handleEmailChange}
                      required
                      autoComplete="new-email"
                    />
                    {emailError && <div className="text-danger">{emailError}</div>}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="userType">User Type</label>
                    <select value={userType} className="form-control" onChange={(event) => setUserType(event.target.value)} required>
                      <option value="A">Admin User</option>
                      <option value="U">Standard User</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-4">
                    <label htmlFor="userStatus">User Status</label>
                    <select value={userStatus} className="form-control" onChange={(event) => setUserStatus(event.target.value)} required>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                {/* <div className="button_group">
                  <button type="button" className="btn bg-danger-subtle text-danger" onClick={() => handleClear()}>

                    Clear Values
                  </button>
                </div> */}
                <div className="button_group">
                  <button className="btn btn-success px-4" onClick={handleSubmit}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
